import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Box,
  AppBar,
  Tabs,
  Tab,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Snackbar, Divider,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SchoolIcon from '@mui/icons-material/School';
import PaidIcon from '@mui/icons-material/Paid';
import PublicIcon from '@mui/icons-material/Public';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // CheckCircle icon for better visual representation
import EventIcon from '@mui/icons-material/EventAvailable';
import ActivitiesIcon from '@mui/icons-material/Star';
import canadahero from '../img/canadahero.jpg';
import Webhead from '../Webhead';
import { useState } from 'react';
import Webfoot from '../Webfoot';


const Scanada = () => {

  const [value, setValue] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const benefits = [
    {
      title: "Affordable Education",
      description: "Canada offers a lower cost of living and tuition fees compared to other popular study destinations.",
      icon: <PaidIcon />
    },
    {
      title: "Innovative and Abundant Research Opportunities",
      description: "Students can engage in groundbreaking research and collaborate with leading experts.",
      icon: <SchoolIcon />
    },
    {
      title: "Immigration Possibilities",
      description: "Canada provides pathways for international students to apply for permanent residency.",
      icon: <PublicIcon />
    },
    {
      title: "Exciting Campus Lifestyle",
      description: "Experience vibrant student life, cultural diversity, and a wide range of extracurricular activities.",
      icon: <EmojiPeopleIcon />
    },
    {
      title: "Healthy and Safe Communities",
      description: "Canada is known for its safety and welcoming atmosphere, providing peace of mind to students.",
      icon: <LiveHelpIcon />
    },
    {
      title: "Work While You Study",
      description: "International students can work part-time while studying, gaining valuable experience.",
      icon: <SchoolIcon />
    },
  ];

  return (
    <div>
      <Webhead />

      <div>
        {/* <StudyInCanada /> */}
        <Container maxWidth="lg" style={{ marginTop: '20px', marginBottom: '40px' }}>

          <Box
            sx={{
              backgroundImage: `url(${canadahero})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              color: 'white',
              padding: '100px 20px',
              textAlign: 'center',
            }}
          >
            <Typography variant="h4" gutterBottom>
              Pursue Your Dreams In Canada
            </Typography>
            <Typography variant="h6" paragraph>
              Complete Admissions Support to Study in Canada
            </Typography>
            <Button variant="contained" color="primary" onClick={() => setSnackbarOpen(true)}>
              Get Started
            </Button>
          </Box>

          {/* Tabs for Different Sections */}
          <AppBar position="static" color="default">
            <Tabs value={value} onChange={handleTabChange} aria-label="tabs">
              <Tab label="Why Study in Canada?" />
              <Tab label="Immigration Process" />
              {/* <Tab label="Student Life" /> */}
            </Tabs>
          </AppBar>

          {/* Tab Content */}
          {value === 0 && (
            <Box sx={{ padding: '5px 0' }}>
              <br />
              <Box sx={{ padding: '20px', backgroundColor: '#F9BB16', borderRadius: '8px', textAlign: 'center' }}>
                <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'black' }}>
                  Study In Canada
                </Typography>
              </Box>
              <br />
              <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'black' }}>

                Life In Canada
              </Typography>
              <Typography variant="body1" paragraph>
                Multicultural Canada is one of the world’s best destinations for migrants. Its cosmopolitan cities, a stable economy and high quality of life make it one of the best countries to live in. Canada also has a huge demand for migrants and has opened its doors to individuals with the skills and talent to give it a global edge. As India’s #1 immigration consultant Allians International has the experience and credibility to help you with your Canada immigration process.
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'black' }}>

                Why Migrate To Canada?
              </Typography>
              <br />
              <Grid container spacing={2} justifyContent="center">

                {benefits.map((benefit, index) => (
                  <Grid item xs={6} sm={6} md={6} key={index}>
                    <Card variant="outlined" sx={{ display: 'flex', alignItems: 'center', padding: '16px', boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', borderRadius: '8px' }}>
                      <IconButton color="primary" sx={{ marginRight: '16px' }}>
                        {benefit.icon}
                      </IconButton>
                      <CardContent sx={{ flex: 1 }}>
                        <Typography variant="h6" gutterBottom>
                          {benefit.title}
                        </Typography>
                        {/* Uncomment below line if you want to include the description */}
                        {/* <Typography variant="body2">{benefit.description}</Typography> */}
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}
          {value === 1 && (
            <Box sx={{ padding: '20px' }}>
              <Box sx={{ padding: '20px', backgroundColor: '#007BFF', borderRadius: '8px', textAlign: 'center' }}>
                <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#fff', marginBottom: 2 }}>
                  Canada Immigration Process
                </Typography>
              </Box>



              {/* New Content Section */}
              <Typography variant="h5" sx={{ fontWeight: 'bold', marginTop: 4, marginBottom: 2 }}>
                Migration to Canada
              </Typography>
              <Typography variant="body1" paragraph>
                Canada has one of the world’s most forward-thinking immigration programs. There are multiple programs by which one can apply to migrate to Canada. These include:
              </Typography>
              <ul style={{ listStyleType: 'none', padding: 0 }}>
                {[
                  "Migration to Canada through the Express Entry program",
                  "Migrate to Canada through the Quebec Selected Workers Program",
                  "Migrate to Canada through the Provincial Nominee Program",
                  "Migrate to Canada as an Entrepreneur/self-employed person",
                  "Migration to Canada for family",
                  "Migrate to Canada as an Investor",
                ].map((program, index) => (
                  <li key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', backgroundColor: '#fff' }}>
                    <SchoolIcon color="primary" style={{ marginRight: '10px', flexShrink: 0 }} />
                    <Typography variant="body1" sx={{ flex: 1 }}>{program}</Typography>
                  </li>
                ))}
              </ul>
              <Typography variant="body1" paragraph>
                The list of programs is dynamic and can change at any point in time. Each of these programs comes with its own set of application criteria and is designed for different types of applicants. Allians helps applicants make the right decision to migrate to Canada by helping them choose the right program and assisting them throughout their migration journey. Our experienced counsellors will be with you at every step of the way as you plan and navigate your migration journey.
              </Typography>

              <Typography variant="h5" sx={{ fontWeight: 'bold', marginTop: 3 }}>
                EXPRESS ENTRY PROGRAM:
              </Typography>
              <Typography variant="body1" paragraph>
                The Express Entry program is one of the most popular ways to migrate to Canada. It was the first immigration program to use skills and points to assess the eligibility of individuals wishing to migrate.
                <br />
                The visa processing time under this program can extend up to six months or less.
              </Typography>

              <Typography variant="h5" sx={{ fontWeight: 'bold', marginTop: 3 }}>
                PROVINCIAL NOMINEE PROGRAM (PNP):
              </Typography>
              <Typography variant="body1" paragraph>
                If you opt for the PNP to apply for your PR visa, these are the steps:
              </Typography>
              <ul style={{ listStyleType: 'none', padding: 0 }}>
                {[
                  "You must apply in the province or region where you desire to settle.",
                  "You could be nominated by the province to apply for a PR visa if your profile meets the eligibility criteria.",
                  "You can apply for your PR visa after you are nominated by a province.",
                ].map((step, index) => (
                  <li key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', backgroundColor: '#fff' }}>
                    <SchoolIcon color="primary" style={{ marginRight: '10px' }} />
                    <Typography variant="body1">{step}</Typography>
                  </li>
                ))}
              </ul>
              <Typography variant="body1" paragraph>
                The criteria for evaluating the PR application differs in each province, but the eligibility requirements are similar to the Express Entry Program.
                <br />
                The PNP is an option you can choose if your points score is not high enough, and you still receive your provincial nomination. When making your application under the PNP, you can choose a province from where it will be easy to get a nomination based on your profile.
              </Typography>
              <Typography variant="body1" paragraph>
                A provincial nomination can help you in two ways to get your PR visa. It can add 600 CRS points to your Express Entry application and makes you eligible to apply for your PR visa directly to IRCC.
              </Typography>

              <Typography variant="h5" sx={{ fontWeight: 'bold', marginTop: 3 }}>
                QUEBEC SKILLED WORKER PROGRAM (QSWP):
              </Typography>
              <Typography variant="body1" paragraph>
                Quebec has its own Provincial Nominee Program known as the Quebec Skilled Worker Program (QSWP). This immigration program was started with the intention to encourage more immigrants to come and settle in Quebec without having to go through the hassle of a lengthy immigration process.
                <br />
                Through this program, skilled workers can apply for the Quebec Selection Certificate or Certificate de sélection du Québec (CSQ). It is not necessary for applicants to have a valid job offer in order to migrate to Quebec. However, those with a job offer are given higher priority.
                <br />
                The QSWP is also based on a points-based system like the Express Entry System.
              </Typography>
            </Box>
          )}

          {value === 2 && (
            <Box sx={{ padding: '20px', borderRadius: '8px', backgroundColor: '#fafafa', marginTop: 4 }}>
              <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
                Student Life
              </Typography>
              <Typography variant="body1" paragraph>
                Student life in Canada is diverse and vibrant. You can expect to engage in:
              </Typography>
              <ul style={{ listStyleType: 'none', padding: 0 }}>
                {[
                  "Participating in clubs and organizations.",
                  "Attending social events and networking opportunities.",
                  "Enjoying the cultural and recreational activities in your area.",
                ].map((activity, index) => (
                  <li key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', backgroundColor: '#fff' }}>
                    <EventIcon color="primary" style={{ marginRight: '10px' }} />
                    <Typography variant="body1">{activity}</Typography>
                  </li>
                ))}
              </ul>
            </Box>
          )}

          <Box sx={{ padding: '20px' }}>
            {/* Canada Immigration Process Heading */}
            <Typography variant="h4" sx={{ fontWeight: 'bold', textAlign: 'center' }}>
              Canada Immigration Process
            </Typography>
            <Divider sx={{ margin: '20px 0' }} />

            {/* Introduction */}
            <Typography variant="body1" paragraph>
              Canada has one of the world’s most forward-thinking immigration programs. There are multiple programs by which one can apply to migrate to Canada. These include:
            </Typography>
            <ul>
              <li>Migration to Canada through the Express Entry program</li>
              <li>Migrate to Canada through the Quebec Selected Workers Program</li>
              <li>Migrate to Canada through the Provincial Nominee Program</li>
              <li>Migrate to Canada as an Entrepreneur/self-employed person</li>
              <li>Migration to Canada for family</li>
              <li>Migrate to Canada as an Investor</li>
            </ul>
            <Divider sx={{ margin: '20px 0' }} />

            {/* Additional Information */}
            <Typography variant="body1" paragraph>
              The list of programs is dynamic and can change at any point in time. Each of these programs comes with its own set of application criteria and is designed for different types of applicants.
              Allians helps applicants in making the right decision to migrate to Canada by helping them choose the right program and assisting them throughout their migration program.
              Our experienced counsellors will be with you at every step of the way as you plan and navigate your migration journey.
            </Typography>
            <Divider sx={{ margin: '20px 0' }} />

            {/* Express Entry Program */}
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              EXPRESS ENTRY PROGRAM:
            </Typography>
            <Typography variant="body1" paragraph>
              The Express Entry program is one of the most popular ways to migrate to Canada. It was the first immigration program to use skills and points to assess the eligibility of individuals wishing to migrate.
              The visa processing time under this program can extend up to six months or less.
            </Typography>
            <Divider sx={{ margin: '20px 0' }} />

            {/* Provincial Nominee Program */}
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              PROVINCIAL NOMINEE PROGRAM (PNP):
            </Typography>
            <Typography variant="body1" paragraph>
              If you opt for the PNP to apply for your PR visa, these are the steps:
            </Typography>
            <ul>
              <li>You must apply in the province or region where you desire to settle.</li>
              <li>You could be nominated by the province to apply for a PR visa if your profile meets the eligibility criteria.</li>
              <li>You can apply for your PR visa after you are nominated by a province.</li>
            </ul>
            <Typography variant="body1" paragraph>
              The criteria for evaluating the PR application differs in each province, but the eligibility requirements are like the Express Entry Program.
              The PNP is an option you can choose if your points score is not high enough, and you still get your provincial nomination.
              A provincial nomination can help you in two ways to get your PR visa: it can add 600 CRS points to your Express Entry application and makes you eligible to apply for your PR visa directly to IRCC.
            </Typography>
            <Divider sx={{ margin: '20px 0' }} />

            {/* Quebec Skilled Worker Program */}
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              QUEBEC SKILLED WORKER PROGRAM (QSWP):
            </Typography>
            <Typography variant="body1" paragraph>
              Quebec has its own Provincial Nominee Program known as the Quebec Skilled Worker Program (QSWP). This immigration program was started to encourage more immigrants to come and settle in Quebec without having to go through the hassle of a lengthy immigration process.
            </Typography>
            <Typography variant="body1" paragraph>
              Through this program, skilled workers can apply for the Quebec Selection Certificate or Certificate de sélection du Québec (CSQ). It is not necessary for applicants to have a valid job offer in order to migrate to Quebec. However, those with a job offer are given higher priority.
              The QSWP is also based on a points-based system like the Express Entry System.
            </Typography>
            {/* <Divider sx={{ margin: '20px 0' }} /> */}

            {/* Eligibility Criteria */}
            {/* <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              Who is Eligible to Apply to Canada?
            </Typography>
            <Typography variant="body1" paragraph>
              While each program to migrate to Canada has different criteria, there are a few things in common. Canadian immigration officials will typically assess migration applications based on:
            </Typography>
            <ul>
              <li>Educational profile</li>
              <li>Professional profile</li>
              <li>Your IELTS score</li>
              <li>French language skills if migrating to Quebec</li>
              <li>References & legal documentation</li>
              <li>Canadian employment documentation</li>
            </ul>
            <Typography variant="body1" paragraph>
              This is not an exhaustive list and is subject to change. Talk to a Allians counsellor to assess your eligibility and increase your chances of migrating to Canada.
            </Typography> */}
          </Box>

          {/* FAQ Accordion */}
          <Box sx={{ marginTop: 4 }}>
            {/* <Typography variant="h5" gutterBottom>Frequently Asked Questions</Typography> */}
            <Accordion elevation={2} sx={{ borderRadius: '8px', marginBottom: 2 }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#f5f5f5' }}>
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
                  Who is Eligible to Apply to Canada?
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ backgroundColor: '#fff' }}>
                <Box sx={{ padding: 2 }}>
                  <p>While each program to migrate to Canada has different criteria, there are a few things in common. Canadian immigration officials will typically assess migration applications based on:</p>
                  <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                    <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                    <Typography variant="body1">Educational profile</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                    <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                    <Typography variant="body1">Professional profile</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                    <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                    <Typography variant="body1">Your IELTS score</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                    <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                    <Typography variant="body1">French language skills if migrating to Quebec</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                    <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                    <Typography variant="body1">References & legal documentation</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                    <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                    <Typography variant="body1">Canadian employment documentation</Typography>
                  </Box>
                  <p>This is not an exhaustive list and subject to change. Talk to a Allians counsellor to assess your eligibility and increase your chances of migrating to Canada.</p>
                </Box>
              </AccordionDetails>
            </Accordion>

          </Box>

          {/* Snackbar for user feedback */}
          <Snackbar
            open={snackbarOpen}
            onClose={handleSnackbarClose}
            message="Get Started button clicked!"
            autoHideDuration={4000}
          />
        </Container>
      </div>
      <Webfoot />
    </div>
  );
};

export default Scanada;